import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSpatialLayer } from '../../../../actions/spatialLayers';
import type { LandingZone } from '../../types';

const GMR_LANDING_ZONES_LAYER_KEY = 'gmr_landing_zones';

interface StaticLayer {
  key?: string;
  isChecked?: boolean;
  spatial_objects?: LandingZone[];
}

interface SpatialLayersState {
  spatialLayers: {
    staticLayers: StaticLayer[] | null;
  };
}

interface UseLandingZonesLayerReturn {
  isPresent: boolean;
  isEnabled: boolean;
  spatialObjects: LandingZone[];
  toggleLandingZoneLayer: (isEnabled: boolean) => void;
}

const useLandingZonesLayer = (): UseLandingZonesLayerReturn => {
  const dispatch = useDispatch();

  const staticLayers = useSelector(
    (state: SpatialLayersState) => state.spatialLayers.staticLayers,
  );

  const layer = useMemo(() => {
    return (staticLayers || []).find(
      (l: StaticLayer) => l?.key === GMR_LANDING_ZONES_LAYER_KEY,
    );
  }, [staticLayers]);

  const isPresent = Boolean(layer);
  const isEnabled = Boolean(layer?.isChecked);
  const spatialObjects = layer?.spatial_objects || [];

  const toggleLandingZoneLayer = (isEnabled: boolean): void => {
    if (layer) {
      dispatch(
        toggleSpatialLayer(GMR_LANDING_ZONES_LAYER_KEY, false, isEnabled),
      );
    }
  };

  return {
    isPresent,
    isEnabled,
    spatialObjects,
    toggleLandingZoneLayer,
  };
};

export default useLandingZonesLayer;
